var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPreparedMealsIcon = function SvgPreparedMealsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 10.084v-5.5h3.666c1.009 0 1.834.825 1.834 1.833v3.667h-5.5zm3.666 7.333a1.839 1.839 0 001.834-1.834v-3.666h-5.5v5.5h3.666zm-5.5-12.834v12.834H3.667a1.839 1.839 0 01-1.834-1.834V6.418c0-1.008.825-1.833 1.834-1.833h9.166zM8.708 11c0-.76-.614-1.375-1.375-1.375-.76 0-1.375.614-1.375 1.375s.615 1.375 1.375 1.375c.761 0 1.375-.614 1.375-1.375z",
    fill: "#004CCC"
  })));
};

export default SvgPreparedMealsIcon;